import { render, staticRenderFns } from "./home-about.vue?vue&type=template&id=a3de1be4&scoped=true"
import script from "./home-about.vue?vue&type=script&lang=js"
export * from "./home-about.vue?vue&type=script&lang=js"
import style0 from "./home-about.vue?vue&type=style&index=0&id=a3de1be4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3de1be4",
  null
  
)

export default component.exports